import React from 'react';
import PropTypes from 'prop-types';
import Theme from './Theme';

import {
  $black,
  $offWhite,
} from '../../styles';

const theme = {
  background: $offWhite,
  copyColor: $black,
  inputTextColor: $black,
};

const AdminTheme = ({ children }) => (
  <Theme theme={theme}>
    {children}
  </Theme>
);

AdminTheme.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminTheme;
